import { Trash } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const DeleteIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => {
  return <Trash width={size} height={size} color={color} {...rest} />;
};

DeleteIcon.displayName = 'DeleteIcon';

export default DeleteIcon;
